// Codes mirror acc.UserInvitationLogStatuses (v2-userland-db). Keep in sync
// with the backend constants: v2-account-service invitation.constants.go and
// v1-auth-data constants.ts (INVITATION_LOG_STATUS).
const STATUS_CREATED = 1
const STATUS_OPENED = 2
const STATUS_CLICKED = 3
const STATUS_ABORTED = 4
const STATUS_CONSUMED = 5
const STATUS_PROCESSED = 6
const STATUS_DROPPED = 7
const STATUS_DEFERRED = 8
const STATUS_BOUNCED = 9
const STATUS_DELIVERED = 10
const STATUS_UNSUBSCRIBED = 11
const STATUS_SPAM_REPORTS = 12
const STATUS_GROUP_UNSUBSCRIBES = 13
const STATUS_GROUP_RESUBSCRIBES = 14
const STATUS_UNKNOWN = 15

const STATUS_DESCRIPTIONS: Record<number, string> = {
  [STATUS_CREATED]: "The invitation was created in the system",
  [STATUS_OPENED]: "The recipient opened the invitation email",
  [STATUS_CLICKED]: "The recipient clicked a link in the invitation email",
  [STATUS_ABORTED]: "The invitation flow was aborted before completion",
  [STATUS_CONSUMED]:
    "The invitation was accepted and used to create an account",
  [STATUS_PROCESSED]: "The email was accepted by the mail server for delivery",
  [STATUS_DROPPED]:
    "The email was rejected and not delivered (e.g. invalid address or spam)",
  [STATUS_DEFERRED]:
    "The email delivery was temporarily delayed and will be retried",
  [STATUS_BOUNCED]: "The email could not be delivered to the recipient",
  [STATUS_DELIVERED]:
    "The email was successfully delivered to the recipient's inbox",
  [STATUS_UNSUBSCRIBED]: "The recipient unsubscribed from these emails",
  [STATUS_SPAM_REPORTS]: "The recipient reported the email as spam",
  [STATUS_GROUP_UNSUBSCRIBES]:
    "The recipient unsubscribed from this email group",
  [STATUS_GROUP_RESUBSCRIBES]: "The recipient resubscribed to this email group",
  [STATUS_UNKNOWN]: "An unrecognized email event was received",
}

export function getStatusBadgeVariant(statusCode: number | null | undefined) {
  if (statusCode === STATUS_CONSUMED) return "positive"
  if (
    statusCode === STATUS_BOUNCED ||
    statusCode === STATUS_DROPPED ||
    statusCode === STATUS_SPAM_REPORTS
  ) {
    return "critical"
  }
  return "neutral"
}

export function getStatusDescription(statusCode: number | null | undefined) {
  if (statusCode === null || statusCode === undefined) return
  return STATUS_DESCRIPTIONS[statusCode]
}
